export enum AppMode {
    MASTER = 'master',
    PREFLIGHT = 'preflight',
}
